'use strict';

import * as html2canvas from 'html2canvas';

export const exportImage = (
  element = { $styles: [], $title: null, $chart: null, $legend: null, $logo: null },
  options = { width: 1168, padding: { top: 10, left: 10, bottom: 10, right: 10 } }
) => {
  return new Promise(resolve => {
    const getClonedNode = $el => {
      const $clonedEl = $el.cloneNode(true);
      // $clonedEl.style.width = '100%';
      return $clonedEl;
    };
    const _options = {
      width: 1168,
      padding: { top: 10, left: 10, bottom: 10, right: 10 },
      fileName: null
    };
    // Set _options
    Object.assign(_options, options);
    if (element.$title && _options.fileName === null) {
      let $fileName = element.$title.querySelector('.supertitle');
      if (!$fileName) {
        $fileName = element.$title.querySelector('.chart-title');
      }
      if (!$fileName) {
        $fileName = element.$title.querySelector('.subtitle');
      }
      if ($fileName) {
        _options.fileName = $fileName.textContent.trim();
      }
    }
    // --
    const className = 'exportContainer';
    const $exportContainer = document.createElement('div');
    $exportContainer.id = className;
    $exportContainer.style.width = `${_options.width}px`;
    for (const [key, value] of Object.entries(_options.padding)) {
      const paddingName = `padding${key.charAt(0).toUpperCase() + key.slice(1)}`;
      $exportContainer.style[paddingName] = `${value}px`;
    }
    for (const $style of element.$styles) {
      $exportContainer.appendChild($style.cloneNode(true));
    }
    if (element.$title) {
      $exportContainer.appendChild(getClonedNode(element.$title));
    }
    let oldChartWidth;
    if (element.$chart) {
      oldChartWidth = element.$chart.style.width;
      element.$chart.style.width = `${_options.width}px`;
      window.dispatchEvent(new Event('resize'));
      $exportContainer.appendChild(getClonedNode(element.$chart));
    }
    const width = _options.width - _options.padding.left - _options.padding.right;

    if (element.$legend) {
      const $legendWrapper = document.createElement('div');
      $legendWrapper.style.marginTop = '20px';
      $legendWrapper.style.width = '100%';
      $legendWrapper.innerHTML = element.$legend.shadowRoot ? element.$legend.shadowRoot.innerHTML : element.$legend.innerHTML;
      $exportContainer.appendChild($legendWrapper);
    }
    if (element.$logo) {
      const $escapLogo = document.createElement('div');
      $escapLogo.style.height = '75px';
      $escapLogo.style.backgroundImage = 'url(' + element.$logo + ')';
      $escapLogo.style.backgroundRepeat = 'no-repeat';
      $escapLogo.style.backgroundSize = 'contain';
      $escapLogo.style.cssFloat = 'right';
      $escapLogo.style.width = '150px';
      $exportContainer.appendChild($escapLogo);
    }
    document.querySelector('body').appendChild($exportContainer);
    html2canvas($exportContainer).then(canvas => {
      if (element.$chart) {
        element.$chart.style.width = oldChartWidth;
      }
      // document.querySelector('body').appendChild(canvas);
      const $downloadLink = document.createElement('a');
      $downloadLink.download = `${_options.fileName}.png`;
      $downloadLink.href = canvas.toDataURL();
      $downloadLink.click();
      // Clear temp elements
      $exportContainer.remove();
      $downloadLink.remove();
      resolve(true);
    });
  });
};

const ExportChart = {
  exportImage: exportImage
};

export default ExportChart;
